import { withRouter } from 'react-router-dom';
import onClickOutside from "react-onclickoutside";
import WithSystem from './../service/WithSystem';
const dataJson = JSON.parse(`{"limit":5,"courses":${window.courseNamesFilter}}`);
class DyanamicDropDown extends React.Component {
  constructor(props) {
    super(props);
    const selectedFilterCourse = this.props.queryFilter['selectedCourse'] ? this.props.queryFilter['selectedCourse'].split(',') : [];
    this.renderData            = dataJson.courses;
    this.selectedItems         = [];
    this.state                 = { searchCourseFilterKeyword: '', dropdownToggle: this.props.dropdownToggle,showallChecked:false };
    this.timeOut               = null;

  }
  dynamicDropdownCallback = () => {
  }
  getQueryStringValue = (key) => {
    var encoded_URI   = this.props.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1");
    var parseData     = decodeURIComponent(encoded_URI);
    if ((parseData == '') || (parseData == null)) {
      return false;
    }
    return parseData;
  }
  bookMarking = () => {
    this.props.history.push(window.bookMarkings());
  }
  searchCourseFilter = (input) => {
    if(this.timeOut)
    { 
      clearTimeout(this.timeOut);
    }
    this.timeOut = setTimeout( async () => {
      let apiResponse  = await this.setCourseFilter(input);
      console.log(apiResponse,'sample111');
      let renderData   = apiResponse.courses;
      this.renderData  = renderData;
      this.setState({ searchCourseFilterKeyword: input })
    }, 600);
    this.setState({ searchCourseFilterKeyword: input })
  }
  setCourseFilter = async (input) => {
    let apiResponse  = await this.FormDataAsJson();
    return apiResponse;
  }
  setSelectedItems     = (selectedId) => {
    let selectedCourse = this.props.queryFilter.selectedCourse;
    selectedCourse     = selectedCourse ? selectedCourse.split(',') : [];
    selectedCourse     = selectedCourse.length ? [...selectedCourse, selectedId] : [selectedId];
    selectedCourse     = selectedCourse.join();
    this.props.setGlobalState({ selectedCourse });

  }
  setUnSelectedItems   = (selectedId) => {
    let selectedCourse = this.props.queryFilter.selectedCourse;
    selectedCourse     = selectedCourse ? selectedCourse.split(',') : [];
    selectedCourse     = selectedCourse.length ? selectedCourse.filter((sCourse) => sCourse != selectedId) : [];
    selectedCourse     = selectedCourse.length ? selectedCourse.join() : false;
    this.props.setGlobalState({ selectedCourse });
  }
  FormDataAsJson   = async () => {
    let apiCall    = `${admin_url}Consolidate_reports/course_filter_listing${__setSsAuthUrl}`;
    let formData   = new FormData();
    formData.append("is_ajax", true);
    formData.append("keyword", this.state.searchCourseFilterKeyword);
    const fetchOptions = {
      method: "POST",
      body: formData
    };
    const response = await fetch(apiCall, fetchOptions);
    return await response.json();
  }
  handleClickOutside = evt => {
    this.setState({ dropdownToggle: false });
  };
  checkedItemRender  = (data,displayLength) => {
    var rowsBlock    = [];
    let totalLength  = data.length;
    var displayCount = displayLength == 'all' ? displayCount = 0 : displayCount = totalLength - 5;
      for (let i = totalLength - 1; displayCount <= i; i--) {
        if (i >= 0) {
        rowsBlock.push(<div key={`course_${data[i]['id']}`} className="form-group">
            <input onClick={() => this.setUnSelectedItems(`${data[i]['id']}`)} type="checkbox" id={`course_${data[i]['id']}`} />
          <label htmlFor={`course_${data[i]['id']}`}>
              <span className="course_name">{data[i]['cb_title']}</span>
            </label>
          </div>);
        }
      }
    return rowsBlock;
  }
  setshowallChecked = () => {
    this.setState({ showallChecked: !this.state.showallChecked });
  }
  render() {
    const selectedFilterCourse = this.props.queryFilter['selectedCourse'] ? this.props.queryFilter['selectedCourse'].split(',') : [];
    let selectedItems          = [];
    let renderData             = this.renderData;
    if (selectedFilterCourse.length) {
      selectedItems            = dataJson.courses.filter((course) => {
        return (selectedFilterCourse.includes(course.id));
      });
      renderData               = this.renderData.filter((course) => {
        return !(selectedFilterCourse.includes(course.id));
      });
    }
    this.selectedItems = selectedItems;
    return (
      <div className="course-select-box mb-10" >
        <span className="filter-subtxt">Course Name</span>
        <div onClick={() => this.setState({ dropdownToggle: !this.state.dropdownToggle })} className={this.state.dropdownToggle == true ? 'course-search active' : 'course-search'} id="traing-course-search" data-val="traing-course-details-section" detail-val="training_course_selected_details">Select Training Course</div>
        <div className={`course-details-section ${this.state.dropdownToggle && 'active'}`} id="course-details-section">
          <div className="course-search-bar">
            <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 10.25C6.10936 10.2498 7.18675 9.87839 8.06063 9.195L10.8081 11.9425L11.6919 11.0587L8.94438 8.31125C9.62813 7.43729 9.99973 6.35965 10 5.25C10 2.49312 7.75688 0.25 5 0.25C2.24313 0.25 0 2.49312 0 5.25C0 8.00687 2.24313 10.25 5 10.25ZM5 1.5C7.06813 1.5 8.75 3.18187 8.75 5.25C8.75 7.31812 7.06813 9 5 9C2.93188 9 1.25 7.31812 1.25 5.25C1.25 3.18187 2.93188 1.5 5 1.5Z" fill="#ACACAC" />
            </svg>
            <input id="txtSearchValue" value={this.state.searchCourseFilterKeyword} onInput={(e) => this.searchCourseFilter(e.target.value)} className="course-searchbox" autoComplete="off" type="text" placeholder="Search Course or Bundle" />
          </div>
          <div className="course-bar-details">
            <div className="selected_course" id="selected_course">
              {this.state.showallChecked ? this.checkedItemRender(selectedItems, 'all') : this.checkedItemRender(selectedItems, 'min')}
              {/*selectedItems.length > 0 && selectedItems.map((course ) => {
                return (<div key={`course_${course.id}`} className="form-group">
                  <input onClick={() => this.setUnSelectedItems(`${course.id}`)} type="checkbox" id={`course_${course.id}`} />
                  <label htmlFor={`course_${course.id}`}>
                    <span className="course_name">{course.cb_title}</span>
                  </label>
                </div>)
              })*/}
              {selectedItems.length > 5 &&
                <div onClick={() => this.setshowallChecked()} className="more-course">
                {this.state.showallChecked ? 'Show less courses' : `${selectedItems.length - 5} more courses selected` }
                  <svg width={9} height={5} viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M-4.08587e-08 0.934738L1.04909 0.0382389L4.49243 3.14412L7.97551 -4.47819e-08L9 0.96448L4.51135 5C4.43757 4.93712 4.34297 4.86149 4.25215 4.78076C2.92338 3.58713 1.59397 2.39321 0.263926 1.19901C0.181627 1.12508 0.0879755 1.0622 -4.34588e-08 0.994221L-4.08587e-08 0.934738Z" fill="#0181FF" />
                </svg></div>
              }
            </div>
            <div className="list_course" id="list_course">
              {renderData.map((course) => {
                return (<div key={`course_${course.id}`} className="form-group" >
                  <input type="checkbox" id={`course_${course.id}`} onClick={() => this.setSelectedItems(`${course.id}`)} />
                  <label htmlFor={`course_${course.id}`}>
                    <span className="course_name">{course.cb_title}</span>
                  </label>
                </div>)
              })}
            </div>
          </div>
        </div>
        <div className="course-selected-details" id="training_course_selected_details"> </div>
      </div>
    );
  }
}
export default withRouter(WithSystem(onClickOutside(DyanamicDropDown)));